import Controller from '@ember/controller';
import { service } from '@ember/service';
import SearchMode from '@linc-technologies/linced-common/enums/person-option-search-mode';

export default class IndexController extends Controller {
  @service
  roles;

  SearchMode = SearchMode;
}
